import React from 'react';
import ProjectAttributeTable from './ProjectAttributeTable';
import ProfileAttributeTable from './ProfileAttributeTable';
import PostAttributeTable from './PostAttributeTable';
import { Typography, Paper, TableContainer } from '@mui/material';

const AttributesTable = ({ onAttributesChange, module, moduleAttributes, initialAttributes }) => {
  return (
    <React.Fragment>
      <Typography variant="body1" fontWeight="bold">
        Required Attributes
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Check the box to make an attribute required.
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        {module === 'Project' && (
          <ProjectAttributeTable
            onAttributesChange={onAttributesChange}
            moduleAttributes={moduleAttributes}
            initialAttributes={initialAttributes}
          />
        )}
        {module === 'Profile' && (
          <ProfileAttributeTable
            onAttributesChange={onAttributesChange}
            moduleAttributes={moduleAttributes}
          />
        )}
        {module === 'Post' && (
          <PostAttributeTable
            onAttributesChange={onAttributesChange}
            moduleAttributes={moduleAttributes}
          />
        )}
      </TableContainer>
    </React.Fragment>
  );
};

export default AttributesTable;